import { render, staticRenderFns } from "./ObiButton.vue?vue&type=template&id=2a6df947&scoped=true&"
import script from "./ObiButton.vue?vue&type=script&lang=js&"
export * from "./ObiButton.vue?vue&type=script&lang=js&"
import style0 from "./ObiButton.vue?vue&type=style&index=0&id=2a6df947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6df947",
  null
  
)

export default component.exports